import { CIMSPageItem } from '../CIMSPageItem'

type CommonCIMSPageItemOptions<
  ID extends string = string,
  ModuleID extends string = string,
  ModuleName extends string = string,
  ModulePathname extends string = string
> = Pick<
  CIMSPageItem<ID, string, string, ModuleID, ModuleName, ModulePathname>,
  'id' | 'module'
>

export function QuickLinks<
  ID extends string,
  ModuleID extends string,
  ModuleName extends string,
  ModulePathname extends string
>({
  id,
  module,
}: CommonCIMSPageItemOptions<ID, ModuleID, ModuleName, ModulePathname>) {
  return new CIMSPageItem<
    ID,
    'Quick Links',
    'quick-links',
    ModuleID,
    ModuleName,
    ModulePathname
  >({
    name: 'Quick Links',
    pathname: 'quick-links',
    id,
    module,
  })
}

export function Types<
  ID extends string,
  ModuleID extends string,
  ModuleName extends string,
  ModulePathname extends string
>({
  id,
  module,
}: CommonCIMSPageItemOptions<ID, ModuleID, ModuleName, ModulePathname>) {
  return new CIMSPageItem<
    ID,
    'Types',
    'types',
    ModuleID,
    ModuleName,
    ModulePathname
  >({
    name: 'Types',
    pathname: 'types',
    id,
    module,
  })
}

export function Disciplines<
  ID extends string,
  ModuleID extends string,
  ModuleName extends string,
  ModulePathname extends string
>({
  id,
  module,
}: CommonCIMSPageItemOptions<ID, ModuleID, ModuleName, ModulePathname>) {
  return new CIMSPageItem<
    ID,
    'Disciplines',
    'disciplines',
    ModuleID,
    ModuleName,
    ModulePathname
  >({
    name: 'Disciplines',
    pathname: 'disciplines',
    id,
    module,
  })
}

export function Notifications<
  ID extends string,
  ModuleID extends string,
  ModuleName extends string,
  ModulePathname extends string
>({
  id,
  module,
}: CommonCIMSPageItemOptions<ID, ModuleID, ModuleName, ModulePathname>) {
  return new CIMSPageItem<
    ID,
    'Notifications',
    'notifications',
    ModuleID,
    ModuleName,
    ModulePathname
  >({
    name: 'Notifications',
    pathname: 'notifications',
    deprecatedPathnames: ['email-lists'],
    id,
    module,
  })
}

export function DispositionTypes<
  ID extends string,
  ModuleID extends string,
  ModuleName extends string,
  ModulePathname extends string
>({
  id,
  module,
}: CommonCIMSPageItemOptions<ID, ModuleID, ModuleName, ModulePathname>) {
  return new CIMSPageItem({
    id,
    module,
    name: 'Disposition Types',
    pathname: 'disposition-types',
  })
}
